import { render, staticRenderFns } from "./YourWines.vue?vue&type=template&id=1816936d&scoped=true"
import script from "./YourWines.vue?vue&type=script&lang=js"
export * from "./YourWines.vue?vue&type=script&lang=js"
import style0 from "./YourWines.vue?vue&type=style&index=0&id=1816936d&prod&lang=css"
import style1 from "./YourWines.vue?vue&type=style&index=1&id=1816936d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1816936d",
  null
  
)

export default component.exports